import { on } from 'delegated-events'

const $form = document.querySelector('.pledge-form')

const fn = {
  init: () => {
    on(
      'change',
      '#PledgeForm_PledgeForm_IsInterested',
      fn.handleMarketingFields
    )
    on('change', '#PledgeForm_PledgeForm_IsOnBehalf', fn.handlePartnersFields)
    on('click', '.pledge-copy-link button', fn.handleCopyLink)

    fn.handleMarketingFields()
    fn.handlePartnersFields()
  },

  handleMarketingFields: () => {
    const $field = document.getElementById('PledgeForm_PledgeForm_IsInterested')
    const $targetFields = document.querySelector('.pledge-marketing-fields')

    if ($field.checked) {
      $targetFields.classList.remove('hidden')
    } else {
      $targetFields.querySelectorAll('input, select').forEach(($input) => {
        const $wrapper = $input.closest('.form-field-wrapper')
        $input.value = null
        $wrapper.classList.remove('is-filled')
      })
      $targetFields.classList.add('hidden')
    }
  },

  handlePartnersFields: () => {
    const $field = document.getElementById('PledgeForm_PledgeForm_IsOnBehalf')
    const $targetFields = document.querySelector('.pledge-partners-fields')

    if ($field && $targetFields) {
      if ($field.checked) {
        $targetFields.classList.remove('hidden')
      } else {
        $targetFields.querySelectorAll('input, select').forEach(($input) => {
          const $wrapper = $input.closest('.form-field-wrapper')
          $input.value = null
          $wrapper.classList.remove('is-filled')
        })
        $targetFields.classList.add('hidden')
      }
    }
  },

  handleCopyLink: () => {
    const $input = document.querySelector('.pledge-copy-link input')

    if ($input) {
      $input.select()
      $input.setSelectionRange(0, 99999)

      document.execCommand('copy')
    }
  },
}

export default {
  can: () => $form,
  run: fn.init,
}
